import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    margin-bottom: 21px;
    width: 100%;

    @media (max-width: 768px){
        margin-bottom: 18px;
        margin-top: 5px;
    }

    @media (max-width: 480px){
        margin-bottom: 15px;
        margin-top: 8px;
    }
`;

const Text = styled.h1`
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: 1.5rem;
    line-height: 1.334;
    letter-spacing: 0em;
    text-align: start;
    margin: 0;
    padding: 0;

    @media (max-width: 768px) {
        font-size: 1.3rem;
        line-height: 1.4;
    }

    @media (max-width: 480px) {
        font-size: 1.1rem;
        line-height: 1.45;
    }

    @media (max-width: 360px) {
        font-size: 1rem;
        line-height: 1.5;
    }
`;

const Underline = styled.div`
    width: 100%;
    max-width: 300px;
    background-color: #006a61;
    height: 2px;
    border-radius: 0px 1px 1px 0px;

    @media (max-width: 480px) {
        max-width: 200px;
    }

    @media (max-width: 360px) {
        max-width: 150px;
    }
`;

const Subtitle = ({ text }) => {
    return (
        <Container>
            <Text>{text}</Text>
            <Underline />
        </Container>
    );
};

export default Subtitle;